import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import SocialLinks from './SocialLinks.jsx'
import { Wordmark } from './Logo.jsx'

export default function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="border-t border-line">
      <div className="mx-auto flex max-w-7xl flex-wrap justify-between gap-4 px-4 py-8 text-[15px] text-subtle sm:px-8">
        <span className="font-extrabold">
          <Wordmark /> <span className="text-ink">· {t('footer.place')}</span>
        </span>
        <div className="flex flex-wrap gap-6">
          <Link to="/about" className="text-subtle no-underline hover:text-ink">
            {t('footer.about')}
          </Link>
          <Link to="/contact?topic=sponsor" className="text-subtle no-underline hover:text-ink">
            {t('footer.sponsor')}
          </Link>
          <Link to="/transparency" className="text-subtle no-underline hover:text-ink">
            {t('donate.transparency')}
          </Link>
          <Link to="/contact" className="text-subtle no-underline hover:text-ink">
            {t('footer.contact')}
          </Link>
        </div>
        <SocialLinks className="w-full" />
      </div>
    </footer>
  )
}
